
import { BookkeepingService } from "@/services/bookkeeping-service";
import { downloadBlob } from "@/utils/blob";
import { printHumanFloat } from "@/utils/pretty-print";
import { VatDeclarationPeriod } from "@/utils/vat-delcaration/period";
import { VatDeclarationResultData } from "@/utils/vat-delcaration/result-data";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			downloading: false,
			sendModal: false,
			xmlFile: null as null | File,
			pdfFile: null as null | File
		};
	},
	props: {
		result: {
			type: Object as ()=> VatDeclarationResultData,
			required: true
		},
		period: {
			type: Object as ()=>VatDeclarationPeriod,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async send(){
			if (this.downloading) return;
			this.downloading = true;
			try{
				await this.fetchPdf();
				await this.fetchXml();
				this.sendModal = true;
			}catch(err){

			}
			this.downloading = false;
		},
		async fetchXml():Promise<File> {
			if (this.xmlFile) {
				return this.xmlFile;
			}
			let result = await BookkeepingService.createVatDeclaration(this.result);
			let fileName = `${this.$ct("common.vat.vat")}-${this.period.toString()}-${this.period.Year}.xml`;
			this.xmlFile = new File([result], fileName);
			return this.xmlFile;
		},
		async fetchPdf():Promise<File>{
			if (this.pdfFile) {
				return this.pdfFile;
			}
			let result = await BookkeepingService.createVatDeclarationPdf(this.result);
			let fileName = `${this.$ct("common.vat.vat")}-${this.period.toString()}-${this.period.Year}.pdf`;
			this.pdfFile = new File([result], fileName);
			return this.pdfFile;
		},
		async download(){
			if (this.downloading) return;
			this.downloading = true;
			try{
				let file = await this.fetchXml();
				downloadBlob(file, file.name);
			}catch(err){
			}
			this.downloading = false;
		},
		async downloadPdf(){
			if (this.downloading) return;
			this.downloading = true;
			try{
				let file = await this.fetchPdf();
				downloadBlob(file, file.name);
			}catch(err){
			}
			this.downloading = false;
		},
		getValue(n:number):string{
			if (this.result.getValue(n) == "") {
				return "";
			}
			return printHumanFloat(parseFloat(this.result.getValue(n)));
		}
	},
	components: {
		AppSendMessageDialog
	},
	i18nEx: {
		componentPrefix: "components.settings-default.vat-declaration-labels"
	}
});
